export default __webpack_public_path__ + "static/media/building.ef4ad465.svg";